import { useSession } from 'next-auth/react';
import { useMutation, UseMutationResult } from 'react-query';
import getCulture from '@/libraries/getters/get-culture';
import getLocale from '@/libraries/getters/get-locale';

type UseMutationClaimInvitationData = Content.Endpoints.ClaimInvitation;

interface UseMutationClaimInvitationError {
  errors: any;
  message?: string;
}

interface UseMutationClaimInvitationParameters {
  parameters: Content.Requests.ClaimInvitationRequestBody;
}

const useMutationClaimInvitation = () => {
  const locale = getLocale();
  const { data: session } = useSession();

  const mutation: UseMutationResult<
    UseMutationClaimInvitationData,
    UseMutationClaimInvitationError,
    UseMutationClaimInvitationParameters
  > = useMutation(
    async variables => {
      const fetchResponse = await fetch('/api/users/claim-invitation', {
        body: JSON.stringify({
          code: variables.parameters.code,
          encryptedBookingHash: variables.parameters.encryptedBookingHash,
          ownerId: variables.parameters.ownerId,
          passengerHash: variables.parameters.passengerHash,
        }),
        headers: {
          ['Accept-Language']: getCulture(locale),
          ['Content-Type']: 'application/json',
          ...(session?.user.accessToken
            ? { ['Authorization']: `Bearer ${session?.user.accessToken}` }
            : {}),
        },
        method: 'POST',
      })
        .then(response => {
          if (response.ok) return response.json();

          throw new Error(`${response.status} - ${response.statusText}`);
        })
        .catch(error => {
          console.error('content.useMutationClaimInvitation', error);

          throw error;
        });

      return fetchResponse;
    },
    {
      onError: async error => error,
    },
  );

  return mutation;
};

export default useMutationClaimInvitation;
